<section class="seccion-mapa mt-3 mb-3">
    <div class="spinner-overlay" *ngIf="cargando==true">
        <div class="spinner"></div>
    </div>
    <div class="container-aux" [style.height.px]="mapa?.alto">


        <section id="mapa" class="mapa-container sombra" [style.height.px]="altoMapa">

            <div class="zoom-icons">
                <div class="zoomIcon" id="zoomIn" (click)="zoomIn()">
                    <img src="../../../../../assets/images/img/zoom_out.png" alt="" />
                </div>
                <div class="zoomIcon" id="zoomOut" (click)="zoomOut()">
                    <img src="../../../../../assets/images/img/zoom_in.png" alt="" />
                </div>
            </div>

            <div class="relative">
                <div class="instrucciones-overlay" *ngIf="mostrarInstrucciones" (click)="ocultarInstrucciones()">
                    <div class="instrucciones-contenedor">
                        <div class="instrucciones-contenido">
                            <p>Desplázate en el mapa y elige la localidad que deseas</p>
                            <button class="btn-aceptar" (click)="ocultarInstrucciones()">Continuar</button>
                        </div>
                    </div>
                </div>

                <div class="mapa" [ngStyle]="getMapaStyles()">

                <div *ngFor="let seccion of mapa?.secciones" class="seccion" [ngClass]="{
                  'seccion-plana': seccion.tipo === 'plana',
                  'seccion-inclinada': seccion.tipo === 'inclinada'
                }" [ngStyle]="getSeccionStyles(seccion)">



                        <div *ngFor="let localidad of seccion.localidadMapas" class="localidad texto-no-seleccionable"
                            [ngStyle]="getLocalidadStyles(localidad)" (mousemove)="onMouseMove($event)"
                            (mouseenter)="showTooltip(localidad)" (mouseleave)="hideTooltip()"
                            (click)="seleccionarCantidadNoNumerada(localidad)">

                            <!-- Mostrar el nombre solo si la forma no es un arco -->
                            <span *ngIf="localidad.forma.type !== 'arco'">
                                {{ localidad.nombre}}
                            </span>

                            <!-- SVG para el arco -->
                            <svg *ngIf="localidad.forma.type === 'arco'" [attr.width]="localidad.forma.anchoArco"
                                [attr.height]="localidad.forma.alto">
                                
                                <path [attr.d]="getPathArco(localidad.forma)" [attr.stroke]="localidad.forma.color_de_borde"
                                    stroke-width="2" [attr.fill]="localidad.forma.color"
                                    (mouseenter)="showTooltip(localidad)" [style.cursor]="'pointer'"
                                    (mouseleave)="hideTooltip()" (mousemove)="onMouseMove($event)"></path>
                                
                                    <text [attr.x]="centerX(localidad.forma.anchoArco)" [attr.y]="localidad.forma.posicionTexto"
                                    text-anchor="middle" alignment-baseline="middle"
                                    [attr.font-size]="localidad.forma.font_size"
                                    [attr.fill]="localidad.forma.color_de_texto" [style.cursor]="'pointer'"
                                    (mouseenter)="showTooltip(localidad)" (mouseleave)="hideTooltip()"
                                    (mousemove)="onMouseMove($event)">
                                    {{localidad.nombre}}
                                </text>
                            </svg>

                            <!-- Tooltip -->
                            <div *ngIf="tooltipVisible" class="hover-info negro">
                                <strong>{{ localidad.precio | currency : 'COP' }}</strong><br />
                                {{ localidad.nombre }}
                            </div>
                        </div>

                        <div *ngFor="let informativo of seccion.informativos" class="informativo texto-no-seleccionable" [ngClass]="{
                            '': informativo.forma.tipo == 1,
                            'triangulo': informativo.forma.tipo == 2,
                            'rombo': informativo.forma.tipo== 3,
                            'pentagono': informativo.forma.tipo == 4,
                            'hexagono': informativo.forma.tipo == 5,
                            'octagono': informativo.forma.tipo == 6,
                            'flecha': informativo.forma.tipo == 7
                          }" [ngStyle]="getInformativoStyles(informativo)">

                            <span *ngIf="informativo.forma.type !== 'arco'">
                                {{ informativo.texto}}
                            </span>

                            <svg *ngIf="informativo.forma.type === 'arco'" [attr.width]="informativo.forma.anchoArco"
                                [attr.height]="informativo.forma.alto">

                                <path [attr.d]="getPathArco(informativo.forma)"
                                    [attr.stroke]="informativo.forma.color_de_borde" stroke-width="2"
                                    [attr.fill]="informativo.forma.color"></path>

                                <text [attr.x]="centerX(informativo.forma.anchoArco)"
                                    [attr.y]="informativo.forma.posicionTexto" text-anchor="middle"
                                    alignment-baseline="middle" [attr.font-size]="informativo.forma.font_size"
                                    [attr.fill]="informativo.forma.color_de_texto">
                                    {{ informativo.texto}}
                                </text>
                            </svg>


                        </div>


                        <div *ngFor="let fila of seccion.filas" class="fila" [ngStyle]="getFilaStyles(fila)">

                            <div *ngFor="let ticket of fila.tickets" [ngStyle]="getAsientoStyles(fila, ticket)"
                                (click)="seleccionarTicket(ticket)" [ngClass]="{ 'seleccionado': isSelected(ticket) }"
                                class="ticket texto-no-seleccionable" (mouseenter)=" showTicketTooltip(ticket)" (mouseleave)="hideTicketTooltip()"
                                (mousemove)="onMouseMove($event)">
                                <div [ngStyle]="getTextoFilaStyles(fila)">{{ getTextoTicket(ticket) }}</div>

                            </div>
                        </div>




                    </div>

                </div>

            </div>



        </section>
        <div class="leyenda sombra">
            <h5 class="leyenda-titulo">Localidades</h5>
            <div *ngFor="let leyenda of mapa?.leyendas; let i = index"
                class="d-flex align-items-center margen-leyendas">
                <div class="circulo-leyenda" [ngStyle]="{ 'background-color': leyenda.color }">
                </div>
                <span class="leyenda-texto">{{ leyenda.nombre }}</span>
            </div>

            <div class="d-flex align-items-center margen-leyendas">
                <div class="circulo-leyenda" [ngStyle]="{ 'background-color': 'red' }">V
                </div>
                <span class="leyenda-texto">Vendido</span>
            </div>


            <div class="d-flex align-items-center margen-leyendas">
                <div class="circulo-leyenda" [ngStyle]="{ 'background-color': 'orange' }">P
                </div>
                <span class="leyenda-texto">En Proceso</span>
            </div>



            <div class="boxTotal mt-auto">
                <div class="cajaTotales">
                    <div class="txtBoxTotal">
                        <div class="montserrat colorLetra"> <strong class="total">Total: </strong> {{valorTotal |
                            currency:'COP'}} </div>
                        <div class="montserrat colorLetra"><strong class="total">Cantidad: </strong> {{cantidadTotal}}
                        </div>
                    </div>
                    <div class="botonFinal">
                        <button *ngIf="eventoId != 1957" class="action_button btnBoxToatl rounded-0" (click)="abrirCarrito()"> COMPRAR</button>
                        <button *ngIf="eventoId == 1957" class="action_button btnBoxToatl rounded-0" (click)="abrirCarrito()"> DONACIÓN</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
